import React from "react"
import { ChevronsRight } from "lucide-mui"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import WorkingHourLabel from "@/components/activities/venues/working_hour_label"
import i18n from "@/i18n"

interface UpdatedWorkingHoursProps {
  activity: any
  className?: string
}

const UpdatedWorkingHours = ({ activity, className }: UpdatedWorkingHoursProps) => {
  const renderWorkingHourChanges = () => {
    const { created, updated, deleted } = activity.parameters.changes

    return (
      <div className="mt-2 space-y-3">
        {created && created.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-green-600">
                {i18n.t("app.activities.venue.working_hours.added")}:
              </span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {created.map((item, index) => (
                <WorkingHourLabel
                  key={`created-${index}`}
                  kind={item.to.kind}
                  weekday={item.to.weekday}
                  startTime={item.to.startTime}
                  endTime={item.to.endTime}
                  startDate={item.to.startDate}
                  endDate={item.to.endDate}
                  closed={item.to.closed}
                />
              ))}
            </div>
          </div>
        )}

        {updated && updated.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-blue-600">
                {i18n.t("app.activities.venue.working_hours.updated")}:
              </span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {updated.map((item, index) => (
                <div key={`updated-${index}`} className="flex flex-row items-center gap-2 flex-wrap">
                  <WorkingHourLabel
                    kind={item.from.kind}
                    weekday={item.from.weekday}
                    startTime={item.from.startTime}
                    endTime={item.from.endTime}
                    startDate={item.from.startDate}
                    endDate={item.from.endDate}
                    closed={item.from.closed}
                  />
                  <ChevronsRight className="text-sm text-gray-400 w-4 h-4" />
                  <WorkingHourLabel
                    kind={item.to.kind}
                    weekday={item.to.weekday}
                    startTime={item.to.startTime}
                    endTime={item.to.endTime}
                    startDate={item.to.startDate}
                    endDate={item.to.endDate}
                    closed={item.to.closed}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {deleted && deleted.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-red-600">
                {i18n.t("app.activities.venue.working_hours.removed")}:
              </span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {deleted.map((item, index) => (
                <WorkingHourLabel
                  key={`deleted-${index}`}
                  kind={item.from.kind}
                  weekday={item.from.weekday}
                  startTime={item.from.startTime}
                  endTime={item.from.endTime}
                  startDate={item.from.startDate}
                  endDate={item.from.endDate}
                  closed={item.from.closed}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <ActivityBase
      data-testid="panel-activity-venue-updated-hours"
      activityKey={activity.key}
      text={
        <>
          {i18n.react("app.activities.venue.updated_working_hours.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          {renderWorkingHourChanges()}
        </>
      }
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default UpdatedWorkingHours
